module.exports = __webpack_public_path__ + "static/media/spellsMain.24b618c2.png";